<template>
  <div class="container">
    <div>
      <Navbar @toggleMenu="toggleMenu" />
      <Menu @closeMenu="closeMenu" :compName="compName" v-if = "showMenu"/>
      <Statusbar v-if="!error && flightLog" :resources ="resources" :slopeId = "slopeId" :date="date" />
    </div> 
    <div class="body">
      <SupervisorPanel v-if="!error && flightLog" :flightLog="flightLog"  />
      <PilotPanel v-if="!error && flightLog" :flightLog="flightLog"  />   
      <IncidentPanel v-if="!error && flightLog" :flightLog="flightLog"  />   

    </div>
    <ActionPanel v-if="!error && flightLog" :flightLog="flightLog" @signOutSupervisor="signOutSupervisor" @signInSupervisor="signInSupervisor" @signOutPilot="signOutPilot" @openSignInDetails="openSignInDetails" @openIncidentDetails="openIncidentDetails"/>
  </div>
  <Modal v-if="signInDetailsVisible" @cancelSignInPilot="cancelSignInPilot" @signInPilot="signInPilot" /> 
  <IncidentDetails v-if="incidentDetailsVisible" @cancelIncident="cancelIncident" @addIncident="addIncident" /> 
</template>

<script>
import Navbar from "../components/Navbar.vue";
import Menu from "../components/Menu.vue";
import Statusbar from "../components/Statusbar.vue";
import SupervisorPanel from "../components/SupervisorPanel.vue";
import PilotPanel from "../components/PilotPanel.vue";
import IncidentPanel from "../components/IncidentPanel.vue";
import ActionPanel from "../components/ActionPanel.vue"
import Modal from "../components/Modal.vue"
import IncidentDetails from "../components/IncidentDetails.vue"
import {computed, onMounted, ref} from 'vue'
import {useStore} from 'vuex'
import { useRouter } from 'vue-router';


export default {
  name: "Home",
  components: { Navbar, Menu, Statusbar, SupervisorPanel, PilotPanel, IncidentPanel, ActionPanel, Modal, IncidentDetails},
  setup() {
    const error = ref(null)
    const store = useStore()
    const router = useRouter()
    const resources = computed(()=> store.state.resources)
    const slopeId = computed(()=> store.state.slopeId)
    const flightLog = computed(() => store.state.flightLog)
    const date= computed(()=>store.state.date)
    const signInDetailsVisible = ref (false)
    const incidentDetailsVisible = ref (false)
    const showMenu = ref (false)

    const compName = 'Home'
    
    const refresh = async () => {
      try {
        await store.dispatch('refresh', slopeId.value)
      } catch (err) {
         console.log(err)
      }
    }

    const init = async() => {
      try {
        await store.dispatch('init')
      } catch (err) {
        console.log(err.message)
        if (err.message==="Request failed with status code 403") {
          router.push({ name: "Login" });          
        } else if (err.message==="Network Error") {
          error.value = "Keine Verbindung zum Server. Bitte kontrolliere, ob du deine mobilen Daten eingeschaltet hast."
        }

      }
    }

    const signOutSupervisor = async() => {
      try {
        const supervisorLogId = flightLog.value.supervisorLogs.filter(sl=> sl.user.id===store.state.user.id && sl.resource.id===slopeId.value && sl.endTime===null)[0].id
        await store.dispatch('signOutSupervisor', supervisorLogId)
      } catch (err) {
         console.log(err)
      }
    }

    const signInSupervisor = async() => {
      try {
        let supervisor = {
          id:null,
          user: store.state.user,
          resource:resources.value.filter(r=>r.id==slopeId.value)[0],
          startTime:null,
          endTime:null
        }
        await store.dispatch('signInSupervisor', supervisor)
      } catch (err) {
         console.log(err)
      }
    }

    const signOutPilot = async() => {
      try {
        const pilotLogId = flightLog.value.pilotLogs.filter(p=> p.user.id===store.state.user.id && p.resource.id===slopeId.value && p.endTime===null)[0].id
        await store.dispatch('signOutPilot', pilotLogId)
      } catch (err) {
         console.log(err)
      }
    }

    const signInPilot = async(pilotLog) => {
      try {
        signInDetailsVisible.value = false
        pilotLog.resource = resources.value.filter(r=>r.id==slopeId.value)[0]
        await store.dispatch('signInPilot', pilotLog)
        console.log(pilotLog)
      } catch (err) {
         console.log(err)
      }
    }

    const openSignInDetails = () => {
      signInDetailsVisible.value = true;
    }

    const cancelSignInPilot  = () =>{
      signInDetailsVisible.value = false;      
    }

    const openIncidentDetails = () => {
      incidentDetailsVisible.value = true;
    }
  
    const addIncident = async(incidentLog) => {
       try {
        incidentDetailsVisible.value = false;
        console.log('Home:')
        console.log (incidentLog)
        incidentLog.resource = resources.value.filter(r=>r.id==slopeId.value)[0]
        await store.dispatch('addIncident', incidentLog)
        console.log(incidentLog)
      } catch (err) {
         console.log(err)
      }
    }
 
    const cancelIncident = () => {
      incidentDetailsVisible.value = false;
    }

    const toggleMenu =() => {
      showMenu.value = !showMenu.value
    }

    const closeMenu =() => {
      showMenu.value = false
    }


    init()

    onMounted(()=> {
      console.log("On Mounted")
      refresh()
    })
    
    return { 
      flightLog, 
      error, 
      slopeId, 
      resources, 
      date,
      signOutSupervisor, 
      signInSupervisor,
      signInPilot, 
      signOutPilot,
      signInDetailsVisible, 
      openSignInDetails,
      cancelSignInPilot,
      incidentDetailsVisible,
      openIncidentDetails,
      addIncident,
      cancelIncident,
      toggleMenu,
      closeMenu,
      showMenu,
      compName
      };
  },
};
</script>

<style scoped>
.container {
  height: 100svh;
  width: 100vw;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 115px 1fr 80px;
}

.body {
  overflow-y: scroll;
}
</style>

